/* eslint-disable @typescript-eslint/ban-ts-comment,no-restricted-syntax */
import { useEffect } from 'react';

export default function useGlobalDOMEvents(props, deps = []) {
  useEffect(() => {
    for (const [key, func] of Object.entries(props)) {
      // @ts-ignore
      window.addEventListener(key, func, false);
    }
    return () => {
      for (const [key, func] of Object.entries(props)) {
        // @ts-ignore
        window.removeEventListener(key, func, false);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
